export default __webpack_public_path__ + "static/caesar-4758d240a72d26e49fa1aa1b589d7e40.png";